var BREFERENCES = (function () {
  function init() {
    new Swiper(".swiper", {
      slidesPerView: 1,
      spaceBetween: 32,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        600: {
          slidesPerView: 2,
        },
        992: {
          slidesPerView: 3,
        },
      },
      preventClicks: false,
      preventClicksPropagation: false,
    });
  }

  return {
    init: init,
  };
})();
